// eslint-disable-next-line jira/import-whitelist
import { preloadPostOfficePlacementWithTenantContext } from '@jira/post-office__post-office-provider-preload-placement/src/preload-placement.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

export const postOfficeJiraForYouCrossflowSolutionsResource: RouteResource<
	Response | null | undefined
> = createResource({
	type: 'POST_OFFICE_PLACEMENT__JIRA_FOR_YOU_CROSSFLOW_SOLUTIONS',
	getKey: () => 'state',
	getData: async (_, { tenantContext }) => {
		const { isAnonymous } = tenantContext;
		if (isAnonymous) {
			return null;
		}

		return preloadPostOfficePlacementWithTenantContext(
			'jira-for-you-crossflow-solutions',
			tenantContext,
		);
	},
	maxAge: Infinity,
});
